import RoomSoldReportIndex from "@/views/report/roomsold/RoomSoldReportIndex.vue";
import RoomSoldReportPrint from "@/views/report/roomsold/RoomSoldReportPrint.vue";

const roomSoldReport = [
  {
    path: "/room-sold-report",
    name: "room-sold-report",
    component: RoomSoldReportIndex,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
  {
    path: "/room-sold-report/print",
    name: "room-sold-report-print",
    component: RoomSoldReportPrint,
    meta: {
      layout: "print",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
];

export default roomSoldReport;
